import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InstaService } from 'app/modules/social/services/insta.service';

@Component({
  selector: 'app-insta-auth',
  templateUrl: './insta-auth.component.html',
  styleUrls: ['./insta-auth.component.scss']
})
export class InstaAuthComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private instaService: InstaService
  ) { }

  ngOnInit() {
    this.route.fragment.subscribe(a => {
      if (a.startsWith('access_token=')) {
        this.instaService.access_token = a.replace('access_token=', '');
      }

      const redirectUrl = sessionStorage.getItem('redirectAfterAuth') || 'projects';
      this.router.navigateByUrl(redirectUrl);
    });
  }

}
